import React, { useState, useEffect, useRef, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
    InputGroup,
    Button,
    Form,
    Spinner
} from "react-bootstrap";
import { SearchIcon } from "../icons";
import "./index.scss";
import { useBetween } from "use-between";
import { useCatalogApi, useCartApi } from "../../pages/useApi";
import Item from "../item";

function debounce(func, wait) {
    let timeout;
    return function(...args) {
        const context = this;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
}

const SearchBar = () => {
    const [isSearching, setIsSearching] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchProducts, setSearchProducts] = useState([]);
    const searchApiRef = useRef({ getProductsByTitle: null, getProductsByAvailability: null });

    const { getProductsByTitle, getProductsByAvailability } = useBetween(useCatalogApi);
    const { cart } = useBetween(useCartApi);
    searchApiRef.current = { getProductsByTitle, getProductsByAvailability };

    const cartQtyByProductId = useMemo(() => {
        const map = {};
        (cart.products || []).forEach((p) => {
            map[p.productId] = p.quantity;
        });
        return map;
    }, [cart.products]);

    const debounceOnChange = React.useCallback(
        debounce((value) => {
            if (value) {
                setIsSearching(true);
                searchApiRef.current
                    .getProductsByTitle(value)
                    .then((res) => {
                        setSearchProducts(res.products || []);
                        setIsSearching(false);
                        setShowDropdown(true);
                    })
                    .catch(() => setIsSearching(false));
            }
        }, 800),
        []
    );

    useEffect(() => {
        getProductsByAvailability("new-release").then((res) => {
            setSearchProducts(res.products || []);
        });
    }, []);

    return (
        <Dropdown
            className='search-form-bar-wrapper'
            onToggle={(val) => setShowDropdown(val)}
            show={showDropdown}
        >
            <Dropdown.Toggle
                className='p-0'
                role='menubar'
                id='dropdown-custom-components'
                as='div'
            >
                <InputGroup className='search-form-bar'>
                    <Form.Control
                        type='text'
                        value={searchText}
                        placeholder='What can we help you find? '
                        aria-label='What can we help you find? '
                        onChange={(e) => {
                            e.stopPropagation();
                            debounceOnChange(e.target.value);
                            setSearchText(e.target.value);
                        }}
                    />
                    <Button variant='outline-secondary' id='button-addon2'>
                        {isSearching ? (
                            <Spinner animation='border' size='sm' />
                        ) : (
                            <SearchIcon width='24' height='24' />
                        )}
                    </Button>
                </InputGroup>
            </Dropdown.Toggle>

            <Dropdown.Menu role='menu'>
                {searchProducts.length
                    ? searchProducts.map((product) => (
                          <Dropdown.ItemText
                              role='menuitem'
                              className='search-item'
                              key={product._id}
                          >
                              <Item
                                  style={true}
                                  product={product}
                                  cartQty={
                                      cartQtyByProductId[
                                          product.InventoryID?.value
                                      ] || 0
                                  }
                              />
                          </Dropdown.ItemText>
                      ))
                    : null}
            </Dropdown.Menu>
        </Dropdown>
    );
};
export default SearchBar;
